/**
 * @runtime-derived-ssot-helper (const-leaf-pinned): an address with its fragment removed -- the ONE spelling of "which
 * page is this" for anything that leaves the browser or outlives the page (telemetry, analytics, stored landing pages,
 * the single sign-on return address).
 *
 * WHY THE FRAGMENT NEVER RIDES A RECORD: it is the part of an address no server ever sees, which is exactly why a
 * browser-side credential travels there -- the single sign-on grant arrives as `#sso_grant=...` (`const/single-sign-on.ts`).
 * `location.href` includes it, so a reader that ships `href` ships whatever the fragment held into a retained store.
 */
export function withoutUrlFragment(href: string): string {
	const at = href.indexOf('#');
	return at === -1 ? href : href.slice(0, at);
}
